import { render, staticRenderFns } from "./nutritionList.vue?vue&type=template&id=39081aac&scoped=true"
import script from "./nutritionList.vue?vue&type=script&lang=js"
export * from "./nutritionList.vue?vue&type=script&lang=js"
import style0 from "./nutritionList.vue?vue&type=style&index=0&id=39081aac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39081aac",
  null
  
)

export default component.exports